// extracted by mini-css-extract-plugin
module.exports = {"stepper":"MobileStepper_stepper__F0fPh","progress":"MobileStepper_progress__Y2zSM"};